var asButtonTypes = function asButtonTypes(types) {
  return types;
};
/**
 * Button Types
 * Visit https://material.io/tools/ to find the icons.
 * Note: the icon names are Pascal case for this factory.
 * The material icons listed above are lowercase and use "_" to join strings.
 * So just convert them when adding them to this set.
 */


var buttonTypes = asButtonTypes({
  APPLY: {
    icon: 'SubdirectoryArrowRight',
    text: 'cmmn:apply'
  },
  BLANK: {
    icon: 'Blank',
    text: ''
  },
  ADD_NEW: {
    icon: 'AddCircle',
    text: 'cmmn:addNew'
  },
  OK: {
    icon: 'ThumbUp',
    text: 'cmmn:ok'
  },
  CANCEL: {
    icon: 'Cancel',
    text: 'cmmn:cancel'
  },
  CLOSE: {
    icon: 'Clear',
    text: 'glbl:close'
  },
  COPY: {
    icon: 'FileCopyOutlined',
    text: 'cmmn:copy'
  },
  DEFAULT: {
    icon: 'CheckCircle',
    text: 'cmmn:default'
  },
  DOWNLOAD: {
    icon: 'SaveAlt',
    text: 'cmmn:download'
  },
  EDIT: {
    icon: 'Edit',
    text: 'cmmn:edit'
  },
  FILTER: {
    icon: 'FilterList',
    text: 'cmmn:toggleFilter'
  },
  IMPORT: {
    icon: 'Publish',
    text: 'cmmn:import'
  },
  SAVE: {
    icon: 'VerticalAlignBottom',
    text: 'cmmn:save'
  },
  SAVE_CLOSE: {
    icon: 'Save',
    text: 'cmmn:saveAndClose'
  },
  SAVE_RUN: {
    icon: 'VerticalAlignBottom',
    text: 'cmmn:saveAndRun'
  },
  SAVE_EXPORT: {
    icon: 'Save',
    text: 'cmmn:saveAndExport'
  },
  EXECUTE: {
    icon: 'PlayArrow',
    text: 'cmmn:execute'
  },
  UNDO: {
    icon: 'Undo',
    text: 'cmmn:undo'
  },
  EMAIL: {
    icon: 'Email',
    text: 'cmmn:email'
  },
  DELETE: {
    icon: 'Delete',
    text: 'cmmn:delete'
  },
  NEXT: {
    icon: 'ArrowForward',
    text: 'cmmn:next'
  },
  REORDER: {
    icon: 'SwapVert',
    text: 'cmmn:reorder'
  },
  RUN_NOW: {
    icon: 'PlayArrow',
    text: 'cmmn:runNow'
  },
  UPDATE: {
    text: 'cmmn:update'
  },
  UPLOAD: {
    text: 'cmmn:upload'
  },
  EXECUTION_HISTORY: {
    icon: 'KeyboardBackspace',
    text: 'cmmn:executionHistory'
  },
  CONTINUE: {
    icon: 'ArrowForward',
    text: 'cmmn:continue'
  },
  DO_NOT_MAP: {
    text: 'cmmn:donotmap'
  },
  AUTOMAP: {
    text: 'cmmn:automap'
  },
  STOP: {
    icon: 'Stop',
    text: 'cmmn:stop'
  },
  ADD_OR_REPLACE: {
    icon: 'AddCircle',
    text: 'cmmn:addOrReplace'
  },
  SELECT_FROM_LIST: {
    icon: 'MoreHoriz',
    text: 'cmmn:selectFromList'
  },
  STAY_ON_PAGE: {
    text: 'cmmn:stayOnThePage'
  },
  LEAVE_PAGE: {
    text: 'cmmn:leaveThePage'
  },
  SYNC_NOW: {
    text: 'cmmn:syncnow'
  },
  TEST_CONNECTION: {
    text: 'cmmn:testConnection'
  },
  BROWSE: {
    text: 'cmmn:browse'
  },
  LOAD: {
    text: 'cmmn:load'
  },
  INFO: {
    icon: 'InfoOutlined',
    text: 'cmmn:info'
  },
  RUN_HISTORY: {
    text: 'cmmn:runHistory'
  },
  CLEAR_MAPPINGS: {
    text: 'cmmn:clearMappings'
  },
  DISCARD: {
    text: 'cmmn:discard'
  },
  // custom icons
  EXPORT: {
    icon: 'Export',
    text: 'cmmn:export'
  },
  CLEAR_FILTER: {
    icon: 'ClearFilter',
    text: 'cmmn:clear'
  },
  FILTER_APPLIED: {
    icon: 'FilterApplied',
    text: 'cmmn:ok'
  },
  FREEFORM: {
    icon: 'FreeForm',
    text: 'cmmn:blFreeForm'
  },
  TABLE: {
    icon: 'Table',
    text: 'cmmn:blTable'
  },
  CATALOG: {
    icon: 'Catalog',
    text: 'cmmn:blCatalog'
  },
  FORMAL_LETTER: {
    icon: 'FormalLetter',
    text: 'cmmn:blFormalLetter'
  },
  DASHBOARD: {
    icon: 'Dashboard',
    text: 'cmmn:blDashBoard'
  },
  TWOCOLUMN_3070: {
    icon: 'TwoColumn3070',
    text: 'cmmn:blTwoCol3070'
  },
  TWOCOLUMN_5050: {
    icon: 'TwoColumn5050',
    text: 'cmmn:blTwoCol5050'
  },
  // grid action/status icons
  COMPLETED: {
    icon: 'CheckCircle',
    text: 'cmmn:completed',
    isActionIcon: true
  },
  SUCCESS: {
    icon: 'CheckCircle',
    text: 'cmmn:success',
    isActionIcon: true
  },
  FAILED: {
    icon: 'Error',
    text: 'cmmn:failed',
    isActionIcon: true
  },
  ERROR: {
    icon: 'Error',
    text: 'cmmn:error',
    isActionIcon: true
  },
  REMOVE: {
    icon: 'RemoveCircle',
    text: 'cmmn:remove',
    isActionIcon: true
  },
  STOPPED: {
    icon: 'Warning',
    text: 'cmmn:stopped',
    isActionIcon: true
  },
  WARNING: {
    icon: 'Warning',
    text: 'cmmn:warning',
    isActionIcon: true
  },
  CANCELLED: {
    icon: 'Warning',
    text: 'cmmn:cancelled',
    isActionIcon: true
  },
  INACTIVE: {
    icon: 'NotInterested',
    text: 'cmmn:inactive',
    isActionIcon: true
  },
  INCOMPLETE: {
    icon: 'RadioButtonUnchecked',
    text: 'cmmn:incomplete',
    isActionIcon: true
  },
  QUEUED: {
    icon: 'Queued',
    text: 'cmmn:queued',
    isActionIcon: true
  },
  RUNNING: {
    icon: 'Running',
    text: 'cmmn:running',
    isActionIcon: true
  },
  // grid statuses without icons
  ACTIVE: {
    text: 'cmmn:inactive',
    isActionIcon: true
  }
});
export { buttonTypes };